export default __webpack_public_path__ + "static/media/navigation_hover-tap.23505dfc.wav";